<script lang="ts" setup>
import { Input } from "@/components/ui/input";

import { useSlots } from "vue";
const props = defineProps({
  modelValue: {
    type: [String, Number],
  },
  disabled: { type: Boolean, default: false },
  blockOutline: { type: Boolean, default: false },
  outlineOffset: { type: String, default: "0px" },
  selectAllOnFocus: { type: Boolean, default: false },
});
defineEmits(["update:modelValue"]);
const slots = useSlots();

const onFocus = (ev: any) => {
  if (props.selectAllOnFocus) {
    ev.target.select();
  }
};
</script>

<template>
  <Input
    type="text"
    :disabled="disabled"
    class="h-[40px] text-input-1 form-input"
    :model-value="modelValue"
    @update:model-value="($event: any) => $emit('update:modelValue', $event)"
    :class="{
      '!focus:outline-none !outline-none shadow-none': blockOutline,
      'focus:outline-focus focus:outline-2': blockOutline != true,
    }"
    :style="{
      'outline-offset': outlineOffset,
    }"
    :data-block-outline="blockOutline"
    @focus="onFocus"
  />
</template>

<style scoped></style>
